import controller from './field-tree-view-controller';

const FieldTreeViewComponent: angular.IComponentOptions = {
  controller,
  controllerAs: 'ctrl',
  bindings: {
    fields: '<',
    onSelect: '&?',
  },
  template: `
    <div class="field-tree-view">
      <tree-view
        nodes="ctrl.treeNodes"
        on-select="ctrl.handleSelection($key)" />
    </div>
  `,
};

export { FieldTreeViewComponent };
